import React from 'react';

export default function Broken() {
  return (
    <div style={{ color: '#fff', textAlign: 'center', padding: '4rem' }}>
      Something went wrong. Please try again later.
    </div>
  );
}